import React from 'react';
import { FiTrendingUp, FiArrowDown, FiSettings, FiTool } from 'react-icons/fi';

const EquipmentSpecsAndPrediction = () => {
  // Information entries layout schema configuration mapping items exactly to the layout card
  const infoRows = [
    { label: "Manufacturer", value: "Foster" },
    { label: "Model", value: "XR600H" },
    { label: "Installed", value: "Mar 2024" },
    { label: "Warranty", value: "Until Mar 2027" }
  ];

  return (
    <div className="w-full max-w-sm flex flex-col gap-5 font-sans select-none">
      
      {/* Block 1: Today vs Yesterday Mini Card Panel */}
      <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-[0_2px_12px_rgba(0,0,0,0.01)] space-y-4">
        {/* Title Bar layout element */}
        <div className="flex items-center gap-2 text-blue-600">
          <FiTrendingUp className="w-4 h-4 stroke-[2.5]" />
          <h4 className="text-[13px] font-bold text-gray-800 tracking-tight">Today vs Yesterday</h4>
        </div>

        {/* Comparison Data Grid readout elements split line */}
        <div className="grid grid-cols-2 gap-4 border-t border-gray-50 pt-3.5">
          <div className="space-y-1">
            <span className="text-[11px] font-bold text-gray-400 block uppercase tracking-tight">Avg Temp</span>
            <p className="text-[18px] font-black text-gray-900 leading-none">2.4°C</p>
          </div>
          <div className="space-y-1">
            <span className="text-[11px] font-bold text-gray-400 block uppercase tracking-tight">Yesterday</span>
            <p className="text-[18px] font-black text-gray-800 leading-none">2.6°C</p>
          </div>
        </div>

        {/* Dynamic drop indicator improvement pill element status text description row */}
        <div className="flex items-center gap-1 text-emerald-600 text-[12px] font-bold">
          <FiArrowDown className="w-3.5 h-3.5 stroke-[2.5]" />
          <span>0.2°C better</span>
        </div>
      </div>

      {/* Block 2: Equipment Information Table Data Card */}
      <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-[0_2px_12px_rgba(0,0,0,0.01)] space-y-4">
        {/* Section title line block code elements style marker design */}
        <div className="flex items-center gap-2 text-gray-500">
          <FiSettings className="w-4 h-4 stroke-[2.2]" />
          <h4 className="text-[13px] font-bold text-gray-800 tracking-tight">Equipment Information</h4>
        </div>

        {/* Specifications Key Value Rows Container elements segment */}
        <div className="space-y-3 border-t border-gray-50 pt-3.5">
          {infoRows.map((row, idx) => (
            <div key={idx} className="flex items-center justify-between text-[12px] font-semibold">
              <span className="text-gray-400">{row.label}</span>
              <span className="text-gray-800 font-bold">{row.value}</span>
            </div>
          ))}
        </div>
      </div>

        {/* Block 3: Maintenance Prediction Score Countdown Panel with Clean SVG Ring */}
        <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-[0_2px_12px_rgba(0,0,0,0.01)] flex items-center justify-between gap-4">
        <div className="space-y-3.5 flex-1">
            {/* Header Title with Hammer Tool outline icon */}
            <div className="flex items-center gap-2 text-gray-500">
            <FiTool className="w-4 h-4" />
            <h4 className="text-[13px] font-bold text-gray-800 tracking-tight">Maintenance Prediction</h4>
            </div>
            
            <div className="space-y-0.5 border-t border-gray-50 pt-3">
            <h5 className="text-[16px] font-black text-emerald-600 leading-none">Excellent</h5>
            <p className="text-[11px] font-semibold text-gray-400">No maintenance predicted</p>
            </div>
        </div>

        {/* Perfectly Rounded SVG Progress Circle Gauge */}
        <div className="relative w-18 h-18 shrink-0 flex items-center justify-center">
            <svg className="w-[100px] h-full transform -rotate-90" viewBox="0 0 36 36">
            {/* 1. Underlying muted background circle tracking ring */}
            <circle 
                cx="18" 
                cy="18" 
                r="16" 
                fill="none" 
                stroke="#F3F4F6" 
                strokeWidth="3.2" 
            />
            {/* 2. Top emerald green active progress indicator vector line arc */}
            <circle 
                cx="18" 
                cy="18" 
                r="16" 
                fill="none" 
                stroke="#10B981" 
                strokeWidth="3.2" 
                strokeLinecap="round" 
                // 100.53 is the full length circumference (2 * Math.PI * 16). 
                // Showing roughly 75% progress path line fill to match your visual theme look.
                strokeDasharray="75, 100.53" 
            />
            </svg>
            
            {/* Center Text Overlays */}
            <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-[18px] font-black text-emerald-600 leading-none tracking-tight">45</span>
            <span className="text-[9px] font-bold text-gray-400 block mt-0.5 uppercase tracking-wide">Days</span>
            </div>
        </div>
        </div>


    </div>
  );
};

export default EquipmentSpecsAndPrediction;
